import React from 'react'
import useLocalStorage from './use-local-storage'

const users = {
  'clerton@lq-enterprise.com': 'clerton@lq-enterprise.com',
  'nassif@lq-enterprise.com': 'nassif@lq-enterprise.com',
  'andre@lq-enterprise.com': 'andre@lq-enterprise.com',
  'tom@lq-enterprise.com': 'tom@lq-enterprise.com',
  'benedikt@lq-enterprise.com': 'benedikt@lq-enterprise.com',
  'sandra@lq-enterprise.com': 'sandra@lq-enterprise.com',
  editor: 'ZLM9iy-SZ7@BKF',
}

export default () => {
  const [user, setUser] = React.useState()
  const [login, doLogin] = useLocalStorage('user', false)

  const signin = (email, password) => {
    const promise = new Promise((resolve, reject) => {
      const userAndPassword = users[email]
      if (userAndPassword && password === userAndPassword) {
        doLogin(email)
        resolve({ user: email })
      } else {
        reject(new Error('wrong login or password'))
      }
      return promise
    })
      .then((response) => {
        setUser(response.user)
        return response.user
      })
      .catch((
        // error
      ) => {
        // console.log(error)
      })
    return promise
  }

  const signout = () => {
    const promise = new Promise((resolve) => {
      doLogin(false)
      resolve()
      return promise
    })
      .then(() => {
        window.localStorage.removeItem('user')
      })
  }

  // Return the user object and auth methods
  return {
    user: user || login,
    signin,
    signout,
  }
}
